import React, { useContext, useEffect, useState } from "react";
import { observer } from "mobx-react";
import Form from 'react-bootstrap/Form';
import Skeleton from 'react-loading-skeleton'
import ReactQuill from 'react-quill';
import { useTranslation, Trans } from "react-i18next";

const FormTextArea = (props) => {
    const { t, i18n } = useTranslation();
    const [value, setValue] = useState("");
    const [textArea, setTextArea] = useState("");

    useEffect(() => {
        var test = props.object?.[props.id] || "";
        setValue(test);
        setTextArea(test);
    }, [props.object]);

    return (

        <Form.Group controlId={props.id}>
            {/*(props.object ? (props.object)?.[props.id] : props.value) || ""*/}
            {props.isLoading ? <Skeleton /> : <Form.Label>{props.label}</Form.Label>}
            {props.isLoading ? <Skeleton height={30} /> : <ReactQuill modules={{ toolbar: props?.showToolbar ? true : false }} readOnly={props.disabled} input="x" theme="snow" onChange={(t) => {
                var text = t;
                var emptyQuill = ["<p><br></p>", "<h1><br></h1>", "<h2><br></h2>", "<h3><br></h3>"];
                if (emptyQuill.indexOf(text) > -1) { text = ""; }
                setValue(text);
                setTextArea(text);
            }} value={textArea} />}

            <Form.Control style={{ display: "none" }} required={props.required} name={props.id} type="text" value={value} onChange={() => { }} />

            <Form.Control.Feedback type="invalid">
                {t('fieldRequired')}
            </Form.Control.Feedback>
        </Form.Group>
    );
};



export default observer(FormTextArea);
